<template lang="pug">
  sweet-modal(ref="sms" title="Отправить SMS")
    .email-modal
      ValidationObserver(v-slot="{ invalid }" ref="form")
        .form-group
          .form-row
            ValidationProvider(
              name="topic"
              rules="notemptySms"
              v-slot="{ errors }"
            )
              textarea#message(
                name="message"
                placeholder="Текст SMS"
                v-model="message"
              )
              span {{ errors[0] }}
        button.btn(
          v-promise-btn
          @click="sendSms"
          :disabled="invalid"
        ) Отправить SMS
</template>

<script>
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

// Validation rules
extend('notemptySms', {
  ...required,
  message: 'Текст SMS не должен быть пустым'
});

export default {
  name: 'SmsModal',

  data() {
    return {
      message: ''
    };
  },

  methods: {
    open() {
      this.resetForm();
      this.$refs.sms.open();
    },

    resetForm() {
      this.message = '';
      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    },

    sendSms() {
      const smsPromise = new Promise(resolve => {
        setTimeout(() => {
          resolve('success');
        }, 2000);
      });

      smsPromise
        .then(() => {
          this.flashSuccess('SMS отправлено');
          console.log({
            to: this.to,
            message: this.message
          });
          this.resetForm();
        })
        .catch(err => {
          this.flashError('Возникла ошибка. Не удалось отправить sms');
          console.log(err);
        });
      return smsPromise;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-row {
  width: 100%;
}
</style>
